<template>
  <div class="blog-explore-container categories-grid s-scroll">
    <!-- Category | page with all categories listed -->
    <!-- Header Section -->
    <section class="blog-explore-header">
      <h1>Categories</h1>
      <p class="subtitle">Explore our articles by topic</p>
    </section>

    <!-- Featured Categories Grid -->
    <section class="explore-grid">
      <div v-for="category in categories"
           :key="category.slug"
           v-show="getCategoryArticleCount(category.slug) > 0"
           class="explore-card">

        <!-- Category Header -->
        <div class="explore-header">
          <a :href="`/pulse/categories/${category.slug}`">
            <div class="category-title-group s-pointer">
              <h2>
                <a class="s-text-router-link">{{ category.name }}</a>
              </h2>

              <div class="show-hover s-hide-mobile-l">
                <small class="s-badge s-badge-no-margin">Open Category</small>
                <s-icon icon-font="s-icon-next-line"/>
              </div>

              <span class="article-count s-badge s-badge-grey-border s-badge-no-margin s-margin-l-auto">
                {{ getCategoryArticleCount(category.slug) }} articles
              </span>
            </div>
          </a>
        </div>

        <!-- Category Description -->
        <p v-if="category.description" class="category-description">{{ category.description }}</p>

        <!-- Latest Articles -->
        <div class="explore-articles-parent">
          <!-- Featured Article (First Article) -->
          <article v-if="getCategoryArticles(category.slug)[0]" class="featured-article">
            <a :href="`/pulse/articles/${getCategoryArticles(category.slug)[0].id}-${getCategoryArticles(category.slug)[0].slug}`"
               class="s-text-router-link">
              <div class="featured-image-container">
                <img :src="getCategoryArticles(category.slug)[0].imageSizes['regular']?.url ?? getCategoryArticles(category.slug)[0].image"
                     :alt="getCategoryArticles(category.slug)[0].title"
                     class="featured-image">
              </div>

              <div class="article-meta">
                <span class="date">{{ formatDate(getCategoryArticles(category.slug)[0].date) }}</span>
              </div>

              <h3 class="featured-title">{{ getCategoryArticles(category.slug)[0].title }}</h3>
              <p class="article-description">{{ getCategoryArticles(category.slug)[0].preview }}</p>
            </a>
          </article>

          <!-- Other Articles -->
          <div class="recent-articles">
            <article v-for="article in getCategoryArticles(category.slug).slice(1, 3)"
                     :key="article.id"
                     class="article-preview">
              <a :href="`/pulse/articles/${article.id}-${article.slug}`"
                 class="article-image s-text-router-link">
                <img :src="article.imageSizes['thumbnail']?.url ?? article.image"
                     :alt="article.title">
              </a>

              <div class="article-content">
                <div class="article-meta">
                  <span class="date">{{ formatDate(article.date) }}</span>
                </div>
                <a :href="`/pulse/articles/${article.id}-${article.slug}`"
                   class="s-text-router-link">
                  <h3>{{ article.title }}</h3>
                </a>
              </div>
            </article>
          </div>
        </div>

        <!-- View More Link -->
        <a v-if="getCategoryArticleCount(category.slug) > 3"
           :href="`/pulse/categories/${category.slug}`"
           class="view-more s-text-router-link">
          View all articles in {{ category.name }} →
        </a>
      </div>
    </section>

    <!-- Subscribe Section -->
    <section class="blog-subscribe">
      <BlogSubscribeForm />
    </section>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue'
import {useData} from 'vike-vue/useData'
import BlogSubscribeForm from '#root/components/BlogSubscribeForm.vue'
import SButton from "#root/components/SButton.vue"
import SIcon from "#root/components/SIcon.vue"

const {categoryResults, categories, error} = useData()

// Helper functions
const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

const getCategoryArticles = (slug) => {
  return categoryResults[slug]?.articles || []
}

const getCategoryArticleCount = (slug) => {
  return categoryResults[slug]?.pagination?.totalDocs || 0
}
</script>
